// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-text-caption_container__d1vnC","textCaption":"roomstay-blog-text-caption_textCaption__z74fM"};